<template>
  <div class="container m:pb-16 pt-8">
    <div class="mb-4">
      <div class="text-center m:text-start">
        <b-headline type="h1" typography="h2" v-html="headline" class="mb-0" />
        <div v-if="description" v-html="description" class="mt-3 mb-8" />
      </div>

      <div class="flex flex-col m:flex-row w-full justify-between mt-6">
        <div class="m:w-5/12 flex flex-col mb-6">
          <signup-form form-id="signup-page" legal-text-alignment="text-left" :hidden-fields="hiddenFields" />
          <a
            class="block text-center cursor-pointer mt-8 js-open-login-popup"
            tabindex="0"
            role="button"
            @keydown="handleLoginLinkKeydown"
          >
            {{ $t("alreadyHaveAnAccount") }}
          </a>
        </div>
        <div class="m:w-6/12 text-center">
          <img :src="imagePath" class="w-full h-auto" loading="lazy" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignupForm from "@/component-library/signup-form"
import BHeadline from "@/component-library/b-headline"
import globals from "@/utils/globals"
import GirlImage from "@/pages/signup-page/images/girl.svg"
import { getSearchParam } from "@/utils/location"

export default {
  name: "SignUpPage",
  components: {
    SignupForm,
    BHeadline
  },
  props: {
    hiddenFields: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    imagePath() {
      return GirlImage
    },
    type() {
      return getSearchParam("type")
    },
    headline() {
      const key = `headline.${this.type}`
      return this.$te(key)
        ? this.$t(key, { totalBooks: globals.totalBooks })
        : this.$t("headline.generic", { totalBooks: globals.totalBooks })
    },
    description() {
      const key = `description.${this.type}`

      if (this.$te(key)) {
        return this.$t(key)
      } else {
        return null
      }
    }
  },
  methods: {
    handleLoginLinkKeydown(event) {
      // Handle Enter (13) and Space (32) keys for accessibility
      if (event.keyCode === 13 || event.keyCode === 32) {
        event.preventDefault()
        // Simulate a click on the element to trigger the js-open-login-popup handler
        event.target.click()
      }
    }
  },
  i18n: {
    messages: {
      en: {
        headline: {
          generic:
            "Get unlimited access to the key ideas of <br class='xs:hidden m:inline-block'/> {totalBooks}+ non-fiction bestsellers",
          sixMonthsFreeTrial: "Expand your knowledge"
        },
        description: {
          sixMonthsFreeTrial: "Sign up with your corporate email and enjoy Blinkist Premium"
        },
        alreadyHaveAnAccount: "Already have an account?"
      },
      de: {
        headline: {
          generic:
            "Hol dir unbegrenzten Zugang zu mehr als <br class='xs:hidden m:inline-block'/>{totalBooks} Kernaussagen der besten Sachbücher",
          sixMonthsFreeTrial: "Erweitere dein Wissen"
        },
        description: {
          sixMonthsFreeTrial: "Melde dich mit deiner Firmen-E-Mail-Adresse an und genieße Blinkist Premium"
        },
        alreadyHaveAnAccount: "Du hast bereits ein Konto?"
      },
      es: {
        headline: {
          generic:
            "Obtén acceso ilimitado a las ideas clave de más de <br class='xs:hidden m:inline-block'/>{totalBooks} bestsellers de no ficción",
          sixMonthsFreeTrial: "Expande tu conocimiento"
        },
        description: {
          sixMonthsFreeTrial: "Regístrate con tu correo corporativo y disfruta de Blinkist Premium"
        },
        alreadyHaveAnAccount: "¿Ya tienes una cuenta?"
      },
      pt: {
        headline: {
          generic:
            "Tenha acesso ilimitado às ideias principais de mais de <br class='xs:hidden m:inline-block'/>{totalBooks} best-sellers de não ficção",
          sixMonthsFreeTrial: "Expanda seu conhecimento"
        },
        description: {
          sixMonthsFreeTrial: "Cadastre-se com seu e-mail corporativo e aproveite o Blinkist Premium"
        },
        alreadyHaveAnAccount: "Já tem uma conta?"
      }
    }
  }
}
</script>
